import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X6PageUpdateModel} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class AddPageStore implements SaveStateHolder {
  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly lessonId: number) {
    makeObservable(this);
    this.name = new StringControl('name', '', validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    if (this.name.invalid)
      return;
    const model: X6PageUpdateModel = {
      LessonId: this.lessonId,
      Name: this.name.value
    };
    this.save = contentLoaders.x6page.insert(model);
  }
}
